<template>
  <div v-if="isShow" class="player-page">
    <div class="content flex match-height">
      <div class="left flex-1">
        <div
          v-if="currentFile.fileType == 'video'"
          id="body-source-wrap-video"
          ref="mrmsplayer"
          class="video"
        />
        <audio-preview
          v-else-if="currentFile.fileType == 'audio'"
          :src="currentAudioUrl"
        />
      </div>
      <div class="body-source-list">
        <div class=" flex-row-center-between">
          <p class="font-color-fff font-18 font-bold tit">文件列表</p>
          <p class="close_im cursor font-bold" @click="closePlayer">x</p>
        </div>
        <div v-for="(item, index) in fileData" :key="item.id">
          <p
            class="item font-14 font-color-fff cursor"
            :class="currentPlayIndex == index ? 'playing' : ''"
            @click="changePlayIndex(index)"
          >
            {{ item.sourceFileName }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import audioPreview from './audioPreview.vue'
import flvjs from 'flv.js/dist/flv.min.js'
import DPlayer from 'dplayer'
window.flvjs = flvjs

export default {
  components: {
    audioPreview
  },
  data() {
    return {
      isShow: false,
      fileData: [],
      currentFile: '',
      currentPlayIndex: 0,
      currentAudioUrl: '',
      currentPlayUrl: '',
      dplayer: null
    }
  },
  mounted() {
    window.onresize = () => {
      const player = document.getElementsByClassName('dplayer-video-wrap')
      if (player.length) {
        if (player[0].outerHTML.indexOf('360videoname') > 0 || player[0].outerHTML.indexOf('position: fixed;') > 0) {
          this.$message.error('播放失败，请关闭该页面重试')
          this.isShow = false
          this.currentFile = ''
          this.fileData = []
          this.dplayer.destroy()
          this.currentAudioUrl = ''
        }
      }
    }
  },
  methods: {
    getFileName(str) {
      return str.split('/').pop()
    },
    closePlayer() {
      document.body.removeAttribute('class', 'overflow-hiden')
      this.isShow = false
    },
    showFull(files, index) {
      document.getElementsByTagName('body')[0].className = 'overflow-hiden'
      this.fileData = files
      this.currentPlayIndex = index
      this.currentFile = files[index]
      this.requestFile()
    },
    requestFile() {
      if (this.isShow === false) {
        this.isShow = true
      }
      if (this.currentFile.fileType === 'video') {
        setTimeout(() => {
          this.play(this.currentFile.savePath)
        }, 1000)
      } else {
        this.currentAudioUrl = this.currentFile.savePath
      }
    },
    changePlayIndex(index) {
      if (this.currentPlayIndex === index) {
        return
      }
      this.currentPlayIndex = index
      this.currentFile = this.fileData[index]
      this.requestFile()
    },
    play(url) {
      if (this.dplayer != null) {
        this.dplayer.destroy()
        this.dplayer = null
      }
      this.dplayer = new DPlayer({
        container: document.getElementById('body-source-wrap-video'),
        autoplay: true,
        theme: '#dba86e',
        loop: false,
        lang: 'zh-cn',
        screenshot: false,
        hotkey: true,
        preload: 'auto',
        mutex: true,
        video: {
          url: url,
          type: 'mp4',
          pic: ''
        }
      })
      const player = document.getElementsByClassName('dplayer-video-wrap')
      console.log(player)
    }
  }
}
</script>

<style lang="scss" scoped>

.player-page {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 9999;
  position: fixed;
  background-color: #333;
  .content {
    .left {
      position: relative;
      flex: 1;
      height: 100%;
      background-color: #111;
      .video {
        width: 100%;
        height: 100%;
      }
    }
    .body-source-list {
      width: 300px;
      height: 100%;
      background-color: #333;
      overflow-y: auto;
      flex-shrink: 0;
      padding: 0 20px;
      .tit {
        line-height: 50px;
      }
      .close_im {
        width: 40px;
        line-height: 50px;
        font-size: 20px;
        font-weight: bold;
        color: #fff;
        text-align: center;
      }
      .item {
        line-height: 34px;
      }
      .item.playing {
        color: #B21F12;
      }
      .item:hover {
        color: #B21F12;
      }
    }
  }
  /deep/.dplayer-info-panel-item.dplayer-info-panel-item-url {
    display: none;
  }
}
</style>
